import { getTrainingGpuCapacity, type TrainingGpuCapacity } from "@/api";
import { PollingController, type PollingSnapshot } from "@/lifecycle";
import { createLogger } from "@/logging";

const logger = createLogger("components/gpu");

// upstream capacity 캐시 TTL 이 15s 다. 그래서 평시 폴링을 그보다 자주 할 필요가 없다.
export const gpuCapacityPollIntervalMs = 15_000;

// 실패해도 직전 값은 유지한다. 503 은 대개 일시적이다. 그래서 계약은 화면을 비우지 말고 직전 값과
// 재시도를 제시하라고 권고한다. 화면은 흐림 + 경고로 값이 최신이 아님을 표시한다.
export type GpuCapacitySnapshot = PollingSnapshot<TrainingGpuCapacity>;

// Training·Evaluation 두 헤더가 GPU 가용량을 동시에 표시할 수 있다. 그래서 폴링 주체를 모듈 하나로 둔다.
// fresh 는 사람이 누른 새로고침에만 보낸다. fresh 요청은 upstream 캐시를 건너뛰고 GKE·k8s 를 직접 읽는다.
export const gpuCapacityController = new PollingController<
  TrainingGpuCapacity,
  { fresh?: boolean }
>({
  load: (options) => getTrainingGpuCapacity({ fresh: options?.fresh }),
  intervalMs: gpuCapacityPollIntervalMs,
  onLoadError: (error) => logger.error("Failed to load GPU capacity.", error),
});
